module.exports = __webpack_public_path__ + "img/icon-1.551a41b.png";